import { render, staticRenderFns } from "./trendingStylesSvg.vue?vue&type=template&id=58d3fe82"
import script from "./trendingStylesSvg.vue?vue&type=script&lang=ts"
export * from "./trendingStylesSvg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports